var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconepartage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#D\xE9grad\xE9_sans_nom_30);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_30",
    y1: 12,
    x2: 20,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#16f7b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21bbee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.79,7.06A4.22,4.22,0,0,0,16,7.67a3.94,3.94,0,0,0,4-3.83A3.94,3.94,0,0,0,16,0a3.94,3.94,0,0,0-4,3.84,3.5,3.5,0,0,0,.15,1L9.7,6.48,5.92,9A4.25,4.25,0,0,0,4,8.58a3.94,3.94,0,0,0-4,3.84,3.94,3.94,0,0,0,4,3.83,4.14,4.14,0,0,0,2.53-.85L9.7,17.52l2.39,1.62a3.5,3.5,0,0,0-.15,1A3.94,3.94,0,0,0,16,24a3.94,3.94,0,0,0,4-3.84,3.94,3.94,0,0,0-4-3.83,4.22,4.22,0,0,0-2.18.61l-3.42-2.31L8,13a3.08,3.08,0,0,0,.06-.61,3.64,3.64,0,0,0-.25-1.32l2.56-1.73Zm2.09-5.42A2.21,2.21,0,0,1,18.15,3.8a2.27,2.27,0,0,1-4.54,0A2.21,2.21,0,0,1,15.88,1.64ZM4,14.71a2.17,2.17,0,1,1,0-4.33,2.17,2.17,0,1,1,0,4.33ZM15.88,18a2.17,2.17,0,1,1-2.27,2.16A2.22,2.22,0,0,1,15.88,18Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconepartage1);
export default __webpack_public_path__ + "static/media/icone partage 1.4a4fd1a9361c6d3c8832987a1e4d6aab.svg";
export { ForwardRef as ReactComponent };